import React, { createContext, useContext, useState, useEffect } from 'react';
import { loadHubFeatureFlags, getHubFeatureFlags, isFeatureEnabled } from '../utils/featureFlags';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';
import { initializeApp, getApps } from 'firebase/app';

const HUB_FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_HUB_FIREBASE_API_KEY || 'AIzaSyD3Nn0PRquje1FPdTvQ9-5jULiaN02JEZs',
  authDomain: process.env.REACT_APP_HUB_FIREBASE_AUTH_DOMAIN || 'jupiter-to-plutoo.firebaseapp.com',
  projectId: process.env.REACT_APP_HUB_FIREBASE_PROJECT_ID || 'jupiter-to-plutoo',
  storageBucket: process.env.REACT_APP_HUB_FIREBASE_STORAGE_BUCKET || 'jupiter-to-plutoo.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_HUB_FIREBASE_MESSAGING_SENDER_ID || '250141547970',
  appId: process.env.REACT_APP_HUB_FIREBASE_APP_ID || '1:250141547970:web:a7bdd7e05f21089f6b0a5b',
};

const HUB_APP_NAME = 'plutoo-hub-readonly';

const getHubDb = () => {
  const existing = getApps().find((a) => a.name === HUB_APP_NAME);
  const hubApp = existing || initializeApp(HUB_FIREBASE_CONFIG, HUB_APP_NAME);
  return getFirestore(hubApp);
};

const getCompanyName = () => process.env.REACT_APP_ACTIVE_COMPANY || 'essexautocentre';

const FeatureFlagsContext = createContext({
  flags: null,
  isEnabled: () => true,
  loading: true,
});

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState(() => getHubFeatureFlags());
  const [loading, setLoading] = useState(flags === null);

  useEffect(() => {
    // Load initial flags
    loadHubFeatureFlags().then((f) => {
      setFlags(f);
      setLoading(false);
    }).catch(() => setLoading(false));

    // Subscribe for live updates from Hub
    try {
      const hubDb = getHubDb();
      const unsubscribe = onSnapshot(
        doc(hubDb, 'companyFeatures', getCompanyName()),
        (snap) => {
          if (snap.exists()) {
            const features = snap.data().features || null;
            setFlags(features);
            setLoading(false);
          }
        },
        () => setLoading(false)
      );
      return () => unsubscribe();
    } catch {
      setLoading(false);
      return undefined;
    }
  }, []);

  const isEnabled = (featureName) => isFeatureEnabled(featureName, flags);

  return (
    <FeatureFlagsContext.Provider value={{ flags, isEnabled, loading }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
